import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/CityLab.css';

const CityLab = () => {
  return (
    <>
      <Helmet>
        <title>CityLab - Urban Innovation & Smart Cities | Redbox Global</title>
        <meta name="description" content="Explore smart cities, sustainable urban transportation, affordable housing solutions, and green spaces. Your guide to urban innovation and the future of cities." />
        <meta name="keywords" content="smart cities, urban innovation, sustainable transportation, affordable housing, urban planning, green spaces, city design, urban development, public transit" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/citylab" />
        <meta property="og:title" content="CityLab - Urban Innovation & Smart Cities | Redbox Global" />
        <meta property="og:description" content="Explore smart cities, sustainable urban transportation, and innovative urban planning solutions." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/citylab" />
        <meta name="twitter:title" content="CityLab - Urban Innovation & Smart Cities | Redbox Global" />
        <meta name="twitter:description" content="Explore smart cities, sustainable urban transportation, and innovative urban planning solutions." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/citylab" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>CityLab</h1>
        <p className="page-subtitle">Urban innovation, design, and the future of cities</p>
      </div>
      
      <div className="page-content">
        <a href="/article/smart-cities-revolution" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1200&h=600&fit=crop" alt="Smart cities" />
            </div>
            <div className="featured-content">
             
              <h2>The Smart Cities Revolution is Here</h2>
              <p>How technology, sustainability, and innovative urban planning are transforming the way we live, work, and move in modern cities around the world.</p>
              <span className="article-meta">This Week's Feature</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/sustainable-urban-transportation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=600&h=400&fit=crop" alt="Urban Transportation" />
              </div>
              <div className="article-content">
                
                <h2>Sustainable Urban Transportation Solutions</h2>
                <p>Cities worldwide are adopting green transit systems to reduce emissions and improve mobility.</p>
                <span className="article-meta">February 3, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/affordable-housing-crisis" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop" alt="Housing" />
              </div>
              <div className="article-content">
               
                <h2>Tackling the Affordable Housing Crisis</h2>
                <p>Innovative approaches to making urban living accessible for all income levels.</p>
                <span className="article-meta">February 2, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/urban-parks-green-spaces" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1519331379826-f10be5486c6f?w=600&h=400&fit=crop" alt="Green Spaces" />
              </div>
              <div className="article-content">
              
                <h2>Urban Parks and Green Spaces Reimagined</h2>
                <p>How cities are prioritizing nature and public spaces for healthier communities.</p>
                <span className="article-meta">February 1, 2026</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default CityLab;
